<template>
  <a-modal
    title="发送红包消息"
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">
      <a-form-item label="提示文本" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea placeholder="请输入" :rows="3"
          v-decorator="['content', { initialValue:'您的红包可能未领取，如已领取请忽略提示~', rules: [{ required: true, message: '必填项' }] }]"/>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSeccess" :loading="confirmLoading">发送</a-button>
    </template>
  </a-modal>
</template>

<script>
import vueLs from 'vue-ls'
import { mapActions } from 'vuex'
export default {
  components: {},
  data() {
    return {
      labelCol: {
        xs: { span: 24 }, sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 }, sm: { span: 13 },
      },
      visible: false,
      form: this.$form.createForm(this),
      unclaimedList: [], // 未领取红包会员列表
      confirmLoading: false,
    }
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),

    show(list) {
      this.visible = true
      this.unclaimedList = list
    },

    handleCancel() {
      this.visible = false
    },

    handleSeccess() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('values=', values)
          let len = this.unclaimedList.length
          if (len > 0) {
            this.$message.success(`正在依次重新发送，大约需要${len *3}秒`)
            for(let i=0; i<len; i++){
              let sub_id = this.unclaimedList[i].sub_id
              let wxid = this.unclaimedList[i].get_member_info.wxid
              setTimeout(()=>{
                // 发红包
                this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
                  robotid: sub_id,
                  type: 'operationcapital',
                  data: {
                    id: [this.unclaimedList[i].id],
                    type: '5',
                  },
                })
                setTimeout(()=>{
                  // 发提示消息
                  const msgData = {
                    user: [wxid],
                    msg_type: '1',
                    msg_content: values.content,
                  }
                  this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
                    robotid: sub_id,
                    type: 'sendmsg',
                    data: msgData,
                  }).then((result) => {
                      // this.$message.success('发送指令成功')
                      this.visible = false
                      this.confirmLoading = false
                    })
                },1000)
              }, i*3000)
            }
          }
        }
      })
    },
  },
}
</script>
<style lang="less">
</style>
